export const REACT_APP_SOCKET_PATH = process.env.REACT_APP_SOCKET_PATH || '';
export const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const REACT_APP_BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL || '';
export const REACT_APP_CLIENT_ID = process.env.REACT_APP_CLIENT_ID || '';
export const REACT_APP_RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';
export const REACT_APP_IS_DEBUG = process.env.REACT_APP_IS_DEBUG === 'true';
export const REACT_APP_TEST_PADDLE = process.env.REACT_APP_TEST_PADDLE || '';
export const REACT_APP_PROD_PADDLE = process.env.REACT_APP_PROD_PADDLE || '';
export const REACT_APP_INTERCOM_ENABLED = process.env.REACT_APP_INTERCOM_ENABLED === 'true';
export const REACT_APP_INTERCOM_MESSENGER_ENABLED = process.env.REACT_APP_INTERCOM_MESSENGER_ENABLED === 'true';
export const REACT_APP_INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID || '';
export const REACT_APP_GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
